var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M6.66934 14.5743H3.46289V12.8428H11.62V14.5743H8.40722V20.4949H6.66934V14.5743Z",
  fill: "inherit"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.3047 12.8428H40.0305V20.5391H38.2989V18.7781V17.1875V14.5743H34.0636V17.1875V18.7781V20.5391H32.3047V12.8428Z",
  fill: "inherit"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1222 14.5743H19.3596V18.7802H15.1222V14.5743ZM13.3633 12.8428H21.0891V20.5391H13.3633V12.8428Z",
  fill: "inherit"
});
var _ref5 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5598 20.5391H22.834V12.8428H24.5656C24.5656 14.831 24.5656 16.8193 24.5656 18.8075H25.8321V16.1692H27.5616V18.8096H28.8282V12.8428H30.5577V20.5391H30.5598Z",
  fill: "inherit"
});
var _ref6 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.6988 8.17755L28.8323 11.1378H30.5617L28.4283 8.17755H30.5617V3.46045H22.8359V11.1568H24.5675L26.6988 8.17755ZM24.5654 5.18991H28.8302V6.44809H25.8509L24.5654 8.17755V5.18991Z",
  fill: "inherit"
});
var _ref7 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.8989 6.44809V8.17755H38.2989V6.44809H34.8989ZM34.0342 5.21937C36.0329 5.21937 38.0296 5.21937 40.0305 5.21937V3.46045H32.3047V11.1568H34.0342C34.0342 9.17694 34.0342 7.19921 34.0342 5.21937Z",
  fill: "inherit"
});
var _ref8 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3633 3.46045H15.1096C15.1096 5.4487 15.1096 7.43695 15.1096 9.42521H19.3449C19.3449 7.43695 19.3449 5.4487 19.3449 3.46045H21.0912V11.1862H13.3633V3.46045Z",
  fill: "inherit"
});
var _ref9 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M6.66934 5.18991H3.46289V3.46045H11.62V5.18991H8.40722V11.1126H6.66934V5.18991Z",
  fill: "inherit"
});
var _ref10 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.72946 1.73157H41.7617V22.2705H1.72946V1.73157ZM0 0H43.4933V24H0V0Z",
  fill: "inherit"
});
var SvgTurftownLogoIcon = function SvgTurftownLogoIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    viewBox: "0 0 44 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTurftownLogoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TurftownLogoIcon.c3284166.svg";
export { ForwardRef as ReactComponent };